import Header from "../../../../../components/common/header";
import { gql, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { formatDateToYearMonthDay } from "../../../../../utils/date/format-date";
import LoadingSpinnerFull from "../../../../../components/common/loading-spinner/loading-spinner-full";

const SETTLEMENT = gql`
  query sellerSettlementGuide {
    calculatePendingSettlement {
      hasRequiredSettlementInfo
      totalPrice
      settlePrice
      settlementStartDate
      settlementEndDate
      nextPayoutDate
    }
  }
`;

const SettlementRequest = () => {
  const { data, loading } = useQuery(SETTLEMENT, {
    fetchPolicy: "network-only",
  });
  const navigate = useNavigate();

  if (loading) {
    return <LoadingSpinnerFull />;
  }

  const settlement = data?.calculatePendingSettlement;

  return (
    <div className="flex flex-col items-center justify-start min-h-screen bg-gray-100 space-y-4 px-4 pb-6">
      <Header title="자동 정산 안내" showBackButton />

      <div className="max-w-xl mx-auto bg-white w-full p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-4 text-center">
          2026년 4월부터 자동 정산으로 변경되었습니다
        </h2>
        <div className="space-y-3 text-gray-700">
          <p>• 이제 별도의 정산 요청 없이 전월 거래내역 기준으로 월 1회 자동 정산됩니다.</p>
          <p>• 현금영수증이나 세금계산서를 직접 발행하실 필요가 없습니다.</p>
          <p>• 거래내역은 부가세 신고 참고자료로 활용하실 수 있습니다.</p>
        </div>
      </div>

      {settlement && (
        <div className="max-w-xl mx-auto bg-white w-full p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4 text-center">이번 달 정산 예정 정보</h2>
          <div className="space-y-3 text-gray-700">
            <div className="flex justify-between items-center">
              <span>집계 기간</span>
              <span className="font-semibold">
                {formatDateToYearMonthDay(new Date(settlement.settlementStartDate))}
                {" ~ "}
                {formatDateToYearMonthDay(new Date(settlement.settlementEndDate))}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span>총 판매 금액</span>
              <span className="font-semibold">
                {settlement.totalPrice.toLocaleString()}원
              </span>
            </div>
            <div className="flex justify-between items-center text-blue-600 font-bold">
              <span>자동 정산 예정 금액</span>
              <span>{settlement.settlePrice.toLocaleString()}원</span>
            </div>
            <div className="flex justify-between items-center">
              <span>다음 지급 예정일</span>
              <span className="font-semibold">
                {formatDateToYearMonthDay(new Date(settlement.nextPayoutDate))}
              </span>
            </div>
          </div>

          {!settlement.hasRequiredSettlementInfo && (
            <div className="mt-4 rounded-lg bg-amber-50 border border-amber-200 p-3 text-amber-800">
              자동 정산을 위해 정산 정보 등록이 필요합니다. 계좌와 사업자 정보를 먼저 확인해주세요.
            </div>
          )}
        </div>
      )}

      <div className="max-w-xl mx-auto bg-white w-full p-6 rounded-lg shadow-md">
        <h3 className="text-lg font-semibold mb-3">세무 처리 안내</h3>
        <div className="space-y-2 text-gray-700">
          <p>• 마감히어로 거래내역은 부가세 신고 시 참고자료로 활용하시면 됩니다.</p>
          <p>• 세무대리인에게는 거래내역 화면 또는 추후 제공되는 다운로드 자료를 전달해주세요.</p>
          <p>• 마감히어로는 플랫폼 수수료에 대한 세금계산서를 발행해드립니다.</p>
        </div>
      </div>

      <div className="max-w-xl mx-auto w-full flex flex-col gap-3">
        <button
          type="button"
          onClick={() => navigate("/boss/my/banking/settlement-detail")}
          className="w-full py-3 bg-blue-500 text-white font-semibold rounded-lg"
        >
          정산 상세내역 보기
        </button>
        <button
          type="button"
          onClick={() => navigate("/boss/my/banking/settlement-info-update")}
          className="w-full py-3 border border-blue-500 text-blue-600 font-semibold rounded-lg bg-white"
        >
          정산 정보 확인하기
        </button>
      </div>
    </div>
  );
};

export default SettlementRequest;
